import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import React from "react";
import { Pie } from "react-chartjs-2";

import { getColor } from "../../../../../utils/getColor";

// Net-new for v2 — R&A has no pie chart. Self-registers the arc element so it works regardless
// of what the rest of the reporting charts register. Legend is deliberately NOT registered
// globally: registration is app-wide, and BarChart/LineChart carry a dormant legend:{display:true}
// that would wake up and render an unlabeled ("undefined") legend on every bar/line chart. The
// pie gets its legend via the chart-local plugins prop below instead.
ChartJS.register(ArcElement, Tooltip);

const PALETTE = [
	getColor("primary", 5),
	getColor("primary", 8),
	getColor("primary", 3),
	getColor("primary", 9),
	getColor("primary", 6),
	getColor("primary", 2),
	getColor("primary", 7),
	getColor("primary", 4),
];

// Chart.js responsive + maintainAspectRatio:false sizes the canvas from its parent, which must be
// position:relative and dedicated to the canvas — else the pie radius collapses (legend still shows).
// data holds null for empty-group aggregates (shapeChartOutput keeps them rather than faking a 0).
export const PieChart: React.FC<{ labels: string[]; data: (number | null)[] }> = ({ labels, data }) => (
	<div className="relative h-full w-full">
		<Pie
			data={{
				labels,
				datasets: [
					{
						data,
						backgroundColor: labels.map((_, index) => PALETTE[index % PALETTE.length]),
						borderColor: "#fff",
						borderWidth: 1,
					},
				],
			}}
			options={{
				maintainAspectRatio: false,
				plugins: { legend: { position: "right" } },
			}}
			plugins={[Legend]}
		/>
	</div>
);

export default PieChart;
